import { Button, Divider } from 'antd';
import { QuestionnaireItemProps } from './types';
import { QuestionnaireItemContainer, QuestionnaireItemDate, QuestionnaireItemTitle, ResultContainer } from './style';
import MaterialIcon from '../../../Icons/MaterialIcon';

const QuestionnaireItem: React.FC<QuestionnaireItemProps> = ({
  title,
  date,
  isDone,
  onClick
}) => {
  return (
    <QuestionnaireItemContainer>
      <QuestionnaireItemTitle>{title}</QuestionnaireItemTitle>
      <QuestionnaireItemDate>{date}</QuestionnaireItemDate>
      <ResultContainer>
        {isDone ? (
          <>
            <p>Resultaten</p>
            <i className="material-icons-sharp">visibility</i>
          </>
        ) : (
          <Button onClick={onClick} type="text" icon={<MaterialIcon className="material-icons-sharp" icon="play_arrow" />}>Start</Button>
        )}
      </ResultContainer>
      <Divider />
    </QuestionnaireItemContainer>
  )
}

export default QuestionnaireItem;